import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { LteManageInventoryService } from 'src/app/services/lte-manage-inventory.service';
import { AddDevicePopupComponent } from '../add-device-popup/add-device-popup.component';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-lte-manage-inventory',
  templateUrl: './lte-manage-inventory.component.html',
  styleUrls: ['./lte-manage-inventory.component.scss']
})
export class LteManageInventoryComponent implements OnInit {

  tabIndex = 0;
  searchQuery = '';
  filterOpen = false;
  showcollection = false;
  filterSearchForm: FormGroup;

  simList: any[] = [];
  lteList: any[] = [];

  simColumns: string[] = [
    'Account Number', 'Username', 'Password', 'Sim Number', 'Package Code',
    'Package Description', 'Supplier', 'Term Date', 'Device Status'
  ];
  routerColumns: string[] = [
    'Model', 'Version', 'Serial', 'Mac',
    'Invoice Number', 'Supplier', 'Date Purchased',
    'Device Status'
  ];
  displayedColumns: string[] = this.simColumns;
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private lteService: LteManageInventoryService,
    private fb: FormBuilder,
    private matDialog: MatDialog
  ) {
    this.filterSearchForm = this.fb.group({
      search: [''],
      status: ['']
    });
  }

  ngOnInit(): void {
    this.getInventory();
  }

  onTabChange(index: any) {
    this.tabIndex = index.index;
    this.searchQuery = '';
    this.filterSearchForm.reset();
    this.displayedColumns = this.tabIndex === 0 ? this.simColumns : this.routerColumns;
    this.getInventory();
  }

  getInventory() {
    const productType = this.tabIndex === 0 ? 1 : 2;

    this.lteService.getLTEInventory(productType, this.searchQuery).subscribe(
      (result: any[]) => {
        if (this.tabIndex === 0) {
          this.simList = result;
          this.dataSource.data = this.simList;
        } else {
          this.lteList = result;
          this.dataSource.data = this.lteList;
        }

        this.showcollection = this.dataSource.data.length > 0;
        this.dataSource.paginator = this.paginator;
      },
      error => {
        console.error('Error fetching inventory', error);
      }
    );
  }
  search() {
    this.searchQuery = this.filterSearchForm.get('search')?.value || '';
    this.getInventory();
  }

  refresh() {
    this.searchQuery = '';
    this.filterSearchForm.reset();
    this.getInventory();
  }
  filterInventory() {
    const status = this.filterSearchForm.get('status')?.value;
    let sourceList = this.tabIndex === 0 ? this.simList : this.lteList;

    if (!status) {
      this.dataSource.data = sourceList;
    } else {
      this.dataSource.data = sourceList.filter(
        item => Number(item.deviceStatus) === Number(status)
      );
    }

    this.showcollection = this.dataSource.data.length > 0;
  }

  exportAsXLSX(prefix: string) {
    const rows = this.dataSource?.filteredData ?? this.dataSource?.data ?? [];
    if (!rows || rows.length === 0) {
      Swal.fire('No records', 'No records to export.', 'info');
      return;
    }
    let exportData: any[] = [];
    if (this.tabIndex === 0) {
      exportData = this.dataSource.data.map(item => ({
        'Account Number': item.accountNumber,
        'Username': item.username,
        'Password': item.password,
        'Sim Number': item.simNumber,
        'Package Code': item.packageCode,
        'Package Description': item.packageDescription,
        'Supplier': item.supplier || item.Supplier,
        'Term Date': item.termDate ? moment(item.termDate).format('DD-MMM-YYYY') : '',
        'Device Status': item.deviceStatus === 1 ? 'Available' : (item.deviceStatus === 2 ? 'Allocated' : item.deviceStatus)
      }));
    } else {
      exportData = this.dataSource.data.map(item => ({
        'Model': item.model,
        'Version': item.version,
        'Serial': item.serial,
        'Mac': item.mac,
        'Invoice Number': item.invoiceNumber,
        'Supplier': item.supplier || item.Supplier,
        'Date Purchased': item.datePurchased ? moment(item.datePurchased).format('DD-MMM-YYYY') : '',
        'Device Status': item.deviceStatus === 1 ? 'Available' : (item.deviceStatus === 2 ? 'Allocated' : item.deviceStatus)
      }));
    }

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.tabIndex === 0 ? 'SIM Inventory' : 'LTE Router Inventory');
    XLSX.writeFile(wb, `${prefix}${moment().format('DDMMYYYYHHmmss')}.xlsx`);
  }
  clearFilter() {
    this.filterSearchForm.reset();
    this.getInventory();
  }
  importexcel(content: string, head: string) {
    const dialogref = this.matDialog.open(AddDevicePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: '50%',
      data: {
        title: content,
        head: head,
        hideAgent: true
      }
    });

    dialogref.afterClosed().subscribe((result) => {
      if (result && content === 'legalexcelimport') {
        this.lteService.uploadInventory(result).subscribe(
          (res: any) => {
            Swal.fire(
              'Success',
              'Uploaded successfully and the process will be started shortly',
              'success'
            );
            this.getInventory();
          },
          (err) => {
            Swal.fire(
              'Error!',
              'Upload failed',
              'error'
            );

          }
        );
      }
    });
  }
}